import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from "react-router-dom"; import App from './App';
import { MsalProvider } from "@azure/msal-react";
import msalInstance from "./msalInstance"

// Optional - This will update account state if a user signs in from another tab or window
msalInstance.enableAccountStorageEvents();

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

//get the current URL to know whether internal or external access
const sender = window.location.hostname;








//if (sender === "aspire-candidate.burnsmcd.com") {
//    //get the referrer
//    const referrer = document.referrer;
//    console.log("Referrer : " + referrer);
//    if (referrer.startsWith("https://careers.burnsmcd.com/welcome-to-employee-ownership") || referrer.startsWith("https://info.burnsmcd.com/welcome-to-employee-ownership-us")) {
//        root.render(
//            <Router>
//                <App audience="External" />
//            </Router>);
//    } else {
//        root.render(
//            <Router>
//                <App audience="Unauthorized" />
//            </Router>);
//    }
//} else {
//    // INTERNAL: ensure user is signed in and then render with MsalProvider
//    (async () => {
//        root.render(
//            <Router>
//                <MsalProvider instance={msalInstance}>
//                    <App audience="Internal" />
//                </MsalProvider>
//            </Router>
//        );
//    })();
//}


/*******************************************************************************************************/
//Using a query string token to block users during testing

// === Token gate helpers (client-side) ===
const TOKEN_QUERY_KEY = 't';
const ACCESS_COOKIE = 'aspiretestaccess';
const ACCESS_COOKIE_VALUE = 'ok';
const ACCESS_TTL_SECONDS = 60 * 60; // 1 hour

const EXPECTED_TOKEN = "testing";//process.env.REACT_APP_ACCESS_TOKEN;

function getQueryParam(name) {
    const url = new URL(window.location.href);
    return url.searchParams.get(name);
}

function stripQueryParam(name) {
    const url = new URL(window.location.href);
    url.searchParams.delete(name);
    // Replace state without adding history entry
    window.history.replaceState({}, '', url.toString());
}

function getCookie(name) {
    return document.cookie
        .split(';')
        .map((c) => c.trim())
        .find((c) => c.startsWith(name + '='))
        ?.split('=')[1];
}

function setCookie(name, value, maxAgeSeconds) {
    // SameSite=Lax so it survives normal navigation; Secure recommended on HTTPS
    document.cookie = `${name}=${value}; Path=/; Max-Age=${maxAgeSeconds}; SameSite=Lax${window.location.protocol === 'https:' ? '; Secure' : ''
        }`;
}

// Compute whether the user has the temporary token access
function computeTokenAccess() {
    const hasAccessCookie = getCookie(ACCESS_COOKIE) === ACCESS_COOKIE_VALUE;
    if (hasAccessCookie) return true;

    const token = getQueryParam(TOKEN_QUERY_KEY);
    if (token && EXPECTED_TOKEN && token === EXPECTED_TOKEN) {
        setCookie(ACCESS_COOKIE, ACCESS_COOKIE_VALUE, ACCESS_TTL_SECONDS);
        stripQueryParam(TOKEN_QUERY_KEY);
        return true;
    }
    return false;
}

const isExternalHost =
    sender === 'aspire-candidate.burnsmcd.com';

// AccessMode mapping:
// 1 = Block both internal and external unless the parameter is included.
// 2 = Block external only unless the parameter is included. Allow internal without the parameter.
// 3 = Block internal only unless the parameter is included. Allow external without the parameter.
// 4 = Allow both internal and external without the parameter.
const accessMode = 4;
function isAllowedByMode(accessMode, isExternalHost, hasTokenAccess) {
    switch (accessMode) {
        case 1: // Block both unless token
            return hasTokenAccess;
        case 2: // Block external unless token; internal allowed
            return isExternalHost ? hasTokenAccess : true;
        case 3: // Block internal unless token; external allowed
            return isExternalHost ? true : hasTokenAccess;
        case 4: // Allow both
            return true;
        default:
            // If server returns an unexpected value, be safe and block unless token
            return hasTokenAccess;
    }
}

// === Require a valid token once, then drop a cookie and clean the URL ===
//const hasAccessCookie = getCookie(ACCESS_COOKIE) === ACCESS_COOKIE_VALUE;
//const token = getQueryParam(TOKEN_QUERY_KEY);

const hasTokenAccess = computeTokenAccess();
const allowAccess = isAllowedByMode(accessMode, isExternalHost, hasTokenAccess);

if (isExternalHost) {
    const referrer = document.referrer;
    if (allowAccess &&
        (referrer.startsWith("https://careers.burnsmcd.com/welcome-to-employee-ownership") || referrer.startsWith("https://info.burnsmcd.com/welcome-to-employee-ownership-us"))) {
        root.render(
            <Router>
                <App audience="External" />
            </Router>
        );
    } else {
        // No/invalid token -> block
        root.render(
            <Router>
                <App audience="Unauthorized" />
            </Router>
        );
    }
} else {
    // INTERNAL: ensure user is signed in and then render with MsalProvider
    if (allowAccess) {
        (async () => {
            root.render(
                <Router>
                    <MsalProvider instance={msalInstance}>
                        <App audience="Internal" />
                    </MsalProvider>
                </Router>
            );
        })();
    } else {
        // No/invalid token -> block
        root.render(
            <Router>
                <App audience="Unauthorized" />
            </Router>
        );
    }


}